/**
 * i18n configuration constants.
 * Single source of truth for supported locales and namespaces.
 */

export const SUPPORTED_LOCALES = ['en', 'he', 'ar'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const RTL_LOCALES: SupportedLocale[] = ['he', 'ar'];
export const DEFAULT_LOCALE: SupportedLocale = 'en';
export const FALLBACK_LOCALE: SupportedLocale = 'en';

export const NAMESPACES = [
  'common',
  'auth',
  'spaces',
  'inventory',
  'manifests',
  'shipments',
  'settings',
] as const;

/**
 * Returns true if the given locale uses right-to-left script.
 */
export function isRTL(locale: SupportedLocale): boolean {
  return RTL_LOCALES.includes(locale);
}
